import cliente from './clienteRepository'
import estado from './estadoRepository'
import municipio from './municipioRepository'
import pais from './paisRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/intranet`

    return {
        cliente: cliente(baseUrl),
        estado: estado(baseUrl),
        municipio: municipio(baseUrl),
        pais: pais(baseUrl),
    }
}